import posthog from 'posthog-js';

// Track current session ID for linking backend events to session replays
let currentSessionId: string | null = null;

// Initialize PostHog on client side
if (typeof window !== 'undefined') {
  const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

  if (apiKey) {
    posthog.init(apiKey, {
      api_host: host,
      defaults: '2025-05-24', // Use latest PostHog features including error tracking
      person_profiles: 'identified_only', // Anonymous by default, identify after purchase
      autocapture: {
        dom_event_allowlist: ['click'], // Capture clicks
        element_allowlist: ['a', 'button'], // On these elements
        css_selector_allowlist: [
          '[data-testid^="button-"]', // CTA buttons with data-testid
          '.lead-popup-form', // Lead capture form
          '.download-link', // Download links
        ],
      },
      capture_pageview: true,
      capture_pageleave: true,
      loaded: (posthog) => {
        if (import.meta.env.DEV) {
          console.log('[PostHog] Initialized successfully');
        }
      },
    });

    // Set up global error listeners for uncaught exceptions
    window.onerror = (message, source, lineno, colno, error) => {
      try {
        posthog.captureException(error || new Error(String(message)), {
          source,
          lineno,
          colno,
          type: 'uncaught_error',
        });
      } catch (e) {
        // Prevent infinite loop if PostHog itself errors
        console.error('[PostHog] Failed to capture exception:', e);
      }
      // Return false to allow default error handling
      return false;
    };

    // Set up global listener for unhandled promise rejections
    window.onunhandledrejection = (event) => {
      try {
        posthog.captureException(event.reason || new Error('Unhandled promise rejection'), {
          type: 'unhandled_promise_rejection',
        });
      } catch (e) {
        // Prevent infinite loop if PostHog itself errors
        console.error('[PostHog] Failed to capture rejection:', e);
      }
    };

    // Capture session ID changes for linking backend events to sessions
    posthog.onSessionId((sessionId) => {
      currentSessionId = sessionId;
      if (import.meta.env.DEV) {
        console.log('[PostHog] Session ID updated:', sessionId);
      }
    });
  } else {
    console.warn('[PostHog] API key not found. Set VITE_PUBLIC_POSTHOG_KEY in .env');
  }
}

/**
 * Get current PostHog session ID for linking backend events to session replays
 * @returns Current session ID or null if not available
 */
export const getSessionId = () => currentSessionId;

export default posthog;
